<template>
  <div v-if="chips.length" class="chips-list d-flex align-items-center">
    <div
      v-for="chip in chips"
      class="chip text-neutral-400 font-size-xs d-flex align-items-center"
    >
      {{ chip?.display(chip.value) }}

      <IconClose @click="$emit('deleteFilter', chip.query)" />
    </div>
  </div>
</template>

<script setup>

const props = defineProps({
  chipsConfig: {
    type: Object,
    default: {},
  },
});

const route = useRoute();

const chips = computed(() => {
  return Object.entries(route.query)
    .map(([queryKey, queryValue]) => {
      if (Object.keys(props.chipsConfig).includes(queryKey)) {
        return {
          ...props.chipsConfig[queryKey],
          query: queryKey,
        };
      }
    })
    .filter(
      (value) =>
        value?.value != null &&
        value?.value !== "" &&
        value?.value !== undefined &&
        !(Array.isArray(value?.value) && value?.value.length === 0)
    );
});

defineExpose({
  chips,
});
</script>

<style lang="scss" scoped>
.chips-list {
  gap: 8px;
  .chip {
    border-radius: 20px;
    border: 1px solid $neutral-150;
    padding: 8px;
    gap: 8px;

    &:hover {
      background: $neutral-50;
      border: 1px solid $neutral-200;
    }
  }
}
</style>
